export default {"src":"/_next/static/media/0xecc68d0451e20292406967fe7c04280e5238ac7d.3519056b.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};